export default {
  'predictions.list.header.companies': 'Company',
  'predictions.list.header.creditor': 'Creditor',
  'predictions.list.header.description': 'Description',
  'predictions.list.header.actions': 'Action',
  
  
  'predictions.searchBar.create': 'Create New Forecast',


  'predictions.form.company': 'Company',
  'predictions.form.creditor': 'Creditor',
  'predictions.form.supplier': 'Supplier',
  'predictions.form.employee': 'Employee',
  'predictions.form.planAccount': 'Plan Account',
  'predictions.form.description': 'Description',
  'predictions.form.documentNumber': 'Document Number',
  'predictions.form.documentType': 'Document Type',
  'predictions.form.paymentDay': 'Payment Day',
  'predictions.form.value': '(US$) Value',
  };